var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgIconExpand(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M8 9.02466L10.8227 6.20198C11.092 5.93265 11.5287 5.93265 11.798 6.20198C12.0673 6.47131 12.0673 6.90797 11.798 7.1773L8.48766 10.4876C8.21833 10.757 7.78167 10.757 7.51234 10.4876L4.202 7.1773C3.93267 6.90797 3.93267 6.47131 4.202 6.20198C4.47132 5.93265 4.90799 5.93265 5.17732 6.20198L8 9.02466Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgIconExpand);
export default __webpack_public_path__ + "static/media/icon-expand.58af486fd5e035902dd6914bdcf7895e.svg";
export { ForwardRef as ReactComponent };